import React from 'react';
import { pressingProgress } from '../utils/pressing';

// How much pressing is left on a job card, shown the same way everywhere.
//
// A pressing line is atomic, so "done" is the total of the lines marked
// completed and the balance is everything else. A line that is only "started"
// still counts as outstanding - the pieces are not pressed until it is finished.
//
//   variant="inline"  one compact line, for job card lists
//   variant="full"    figures plus a progress bar, for job card detail views
export default function PressingBalance({ jobCard, variant = 'inline', className = '' }) {
  const p = pressingProgress(jobCard);
  if (!p.hasPressing) return null;

  const complete = p.balance === 0;
  const tone = complete ? 'text-green-700' : 'text-amber-700';

  if (variant === 'inline') {
    return (
      <span
        className={`text-xs inline-flex items-center gap-1.5 ${className}`}
        title={`${p.linesDone} of ${p.lines} pressing lines finished`}
        data-testid="pressing-balance-inline"
      >
        <span className="text-gray-500">Press</span>
        <span className="font-medium text-gray-700">{p.done}/{p.planned}</span>
        {complete ? (
          <span className="text-green-700 font-semibold">done</span>
        ) : (
          <span className={`font-semibold ${tone}`}>{p.balance} left</span>
        )}
      </span>
    );
  }

  return (
    <div className={className} data-testid="pressing-balance-full">
      <div className="flex items-baseline justify-between gap-3">
        <span className="text-xs text-gray-500">Pressing</span>
        <span className="text-xs text-gray-400">
          {p.linesDone}/{p.lines} lines
        </span>
      </div>
      <div className="flex items-baseline gap-2 mt-0.5">
        <span className={`text-2xl font-bold ${complete ? 'text-green-700' : 'text-amber-700'}`}>
          {complete ? 'Done' : p.balance}
        </span>
        <span className="text-xs text-gray-500">
          {complete ? `all ${p.planned} pressed` : `left of ${p.planned} · ${p.done} done`}
        </span>
      </div>
      <div className="h-1.5 rounded-full bg-gray-200 overflow-hidden mt-2">
        <div
          className={complete ? 'h-full bg-green-500' : 'h-full bg-amber-500'}
          style={{ width: `${p.pct}%` }}
        />
      </div>
    </div>
  );
}
